/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const DELETEEVENT= createAsyncThunk(
  "deleteEvent/deleteEvent",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const deleteEventSlice = createSlice({
  name: "deleteEventSlice",
  initialState: {
    deleteEvent: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfdeleteEvent: (state) => {
        state.deleteEvent.loading = false
        state.deleteEvent.error = false
        state.deleteEvent.data = []
        state.deleteEvent.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(DELETEEVENT.fulfilled, (state, action) => {
      state.deleteEvent = {
        ...state.deleteEvent,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DELETEEVENT.pending, (state, action) => {
      state.deleteEvent = {
        ...state.deleteEvent,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DELETEEVENT.rejected, (state, action) => {
      state.deleteEvent = {
        ...state.deleteEvent,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const deleteEventAction = {
    DELETEEVENT,
};

export { deleteEventAction };
export default deleteEventSlice.reducer;
export const {setInitialStateOfdeleteEvent} = deleteEventSlice.actions